<div [ngClass]="{'course-froala' : isCourse}" [froalaEditor]="options" [(froalaModel)]="content"></div>
